const Layout = ({ children, ...props }) => {
  return (
    <>
      <div>
        {props.show && <div className={"modal-backdrop fade show"}></div>}
        {children}
      </div>
    </>
  )
}

export default Layout
